import React from 'react'
import AppSidebar from '../component/AppSidebar'
import AppContent from '../component/AppContent'
import AppHeader from '../component/AppHeader'
import AppFooter from '../component/AppFooter'
import { useSelector } from 'react-redux'

const DefaultLayouts = () => {

  const sidebarShow = useSelector((state) => state.SidebarSlice.isSidebarshow)


  return (
    <div className={sidebarShow ? 'main-layout hide' : 'main-layout'}>
      <AppSidebar />
      <div className={sidebarShow ? "wrapper d-flex flex-column min-vh-100 hide" : "wrapper d-flex flex-column min-vh-100"}>
        <AppHeader />
        <div className="body flex-grow-1">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default DefaultLayouts